import z from "zod";
import { DTOObjectMeta } from "../../aux/meta";

export const DTOFigmaComponentGroup = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  persistentId: z.string(),
  isRoot: z.boolean(),
  brandId: z.string(),
  meta: DTOObjectMeta,
  childrenIds: z.string().array(),
});

export const DTOFigmaComponentGroupListResponse = z.object({
  groups: DTOFigmaComponentGroup.array(),
});

export type DTOFigmaComponentGroup = z.infer<typeof DTOFigmaComponentGroup>;
export type DTOFigmaComponentGroupListResponse = z.infer<typeof DTOFigmaComponentGroupListResponse>;
